/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';

const TableBody = _ref => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement("tbody", _extends({
    "aria-live": 'polite' ,
    className: className
  }, rest), children);
};
TableBody.propTypes = {
  /**
   * `polite` Adjust the notification behavior of screen readers
   */
  'aria-live': PropTypes.oneOf(['polite', 'assertive', 'off']),
  children: PropTypes.node,
  className: PropTypes.string
};

export { TableBody as default };
